<template>
  <div v-html="html" class="markdown"></div>
</template>

<script>
import { marked } from "marked";
import * as DOMPurify from "dompurify";

export default {
  props: {
    value: {
      required: true,
    },
  },

  computed: {
    html() {
      return this.value ? DOMPurify.sanitize(marked.parse(this.value.toString())) : "";
    },
  },
};
</script>

<style lang="scss">
.markdown {
  p,
  ol,
  ul {
    margin: 1em 0;
  }

  li {
    margin: 0.25em 0;
  }

  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
}
</style>
